import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// this is for persist current page scroll position
const useScrollRestoration = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === "POP") {
      // Restore previous scroll position when navigating back
      const savedPosition = sessionStorage.getItem(
        `scrollPosition_${pathname}`
      );
      if (savedPosition) {
        window.scrollTo({
          top: parseInt(savedPosition, 10),
          behavior: "instant",
        });
      }
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }

    const handleScroll = () => {
      sessionStorage.setItem(
        `scrollPosition_${pathname}`,
        window.scrollY.toString()
      );
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      handleScroll();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname, navigationType]);
};

export default useScrollRestoration;
